import { LoaderCircle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FormField, inputClass } from "@/components/form/FormField";
import { cn } from "@/lib/utils";

export const CaptchaField = ({ captcha: c }) => (
  <FormField id="captcha" label="Kode Captcha" required hint="Ketik kode pada gambar (huruf besar/kecil tidak dibedakan).">
    <div className="flex items-center gap-2">
      <div className="flex h-16 w-[180px] shrink-0 items-center justify-center overflow-hidden rounded-xl border border-slate-200 bg-white">
        {c.captcha ? (
          <img src={c.captcha.image} alt="Kode captcha" className="h-16 w-[180px]" data-captcha-id={c.captcha.captcha_id} data-testid="captcha-image" />
        ) : (
          <LoaderCircle className="h-5 w-5 animate-spin text-emerald-600" />
        )}
      </div>
      <Button type="button" variant="outline" size="icon" onClick={c.refresh} disabled={c.loading} aria-label="Muat ulang captcha" className="h-11 w-11 shrink-0 rounded-xl" data-testid="captcha-refresh-btn">
        <RefreshCw className={cn("h-4 w-4", c.loading && "animate-spin")} />
      </Button>
    </div>
    <Input
      id="captcha"
      value={c.answer}
      onChange={(e) => c.setAnswer(e.target.value.toUpperCase())}
      maxLength={5}
      autoComplete="off"
      placeholder="Masukkan kode"
      className={cn(inputClass(false), "font-semibold uppercase tracking-[0.3em]")}
      data-testid="captcha-input"
    />
  </FormField>
);
